/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */
// @ts-nocheck
import React from "react";

import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.css";
import "rc-pagination/assets/index.css";

import { mergeStyles } from "@fluentui/react";

import * as serviceWorker from "./ServiceWorker";

import { AuthProvider } from "Authentication/AuthProvider";

import AppContainer from "./Containers/App/AppContainer";
import store from "./Store";

mergeStyles({
  ":global(body,html,#root)": {
    margin: "0",
  },
});

ReactDOM.render(
  <React.StrictMode>
    <AuthProvider>
      <Provider store={store}>
        <Router>
          <AppContainer />
        </Router>
      </Provider>
    </AuthProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
